import { c as _c } from "react/compiler-runtime";
import { NumberRangeFields } from "@components/common/faro-table/faro-table-filter/number-range-filter/number-range-fields";
import { getNumberRangeFilterId, parseNumberRangeFilterId } from "@components/common/faro-table/faro-table-filter/number-range-filter/number-range-filter-utils";
import { FilterChip } from "@components/common/faro-table/faro-table-filter/filter-chip";
import { Menu } from "@flat-ui";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { Box } from "@mui-wrapper";
import { useState } from "react";

/** Width of the dropdown, which fits the fields of the range */
const DROPDOWN_WIDTH = "260px";
/**
 * A chip to filter by a number, e.g. the projects of a group. Its dropdown lets the user type a
 * minimum and a maximum, kept in the URL as e.g. "range:2_10". Only one range is applied at a time.
 */
export function NumberRangeFilterChip(t0) {
  const $ = _c(30);
  const {
    filteredColumn,
    label,
    tableType
  } = t0;
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    getFilterIdsForColumn,
    updateFilterItem
  } = useFilterQueryParams();
  let activeFilterId;
  let t1;
  if ($[0] !== filteredColumn || $[1] !== getFilterIdsForColumn) {
    activeFilterId = getFilterIdsForColumn(filteredColumn).at(0);
    t1 = activeFilterId === undefined ? undefined : parseNumberRangeFilterId(activeFilterId);
    $[0] = filteredColumn;
    $[1] = getFilterIdsForColumn;
    $[2] = activeFilterId;
    $[3] = t1;
  } else {
    activeFilterId = $[2];
    t1 = $[3];
  }
  const activeRange = t1;
  let t2;
  if ($[4] !== activeFilterId || $[5] !== filteredColumn || $[6] !== tableType || $[7] !== updateFilterItem) {
    t2 = function applyRange(range) {
      const filterId = range ? getNumberRangeFilterId(range) : activeFilterId;
      if (filterId !== undefined && (!range || filterId !== activeFilterId)) {
        updateFilterItem({
          tableType,
          filteredColumn,
          filterId,
          shouldReplaceFilterInColumn: true
        });
      }
      setAnchorEl(null);
    };
    $[4] = activeFilterId;
    $[5] = filteredColumn;
    $[6] = tableType;
    $[7] = updateFilterItem;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const applyRange = t2;
  const t3 = !!anchorEl;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = event => setAnchorEl(event.currentTarget);
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== filteredColumn || $[11] !== label || $[12] !== t3) {
    t5 = <FilterChip filteredColumn={filteredColumn} label={label} shouldHaveDropdown={true} isDropdownOpen={t3} onClick={t4} />;
    $[10] = filteredColumn;
    $[11] = label;
    $[12] = t3;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = !!anchorEl;
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setAnchorEl(null);
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      paper: {
        sx: {
          width: DROPDOWN_WIDTH
        }
      }
    };
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== label) {
    t9 = label.toLowerCase();
    $[16] = label;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setAnchorEl(null);
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== activeRange || $[20] !== applyRange || $[21] !== t9) {
    t11 = <NumberRangeFields countedName={t9} activeRange={activeRange} onCancel={t10} onApply={applyRange} />;
    $[19] = activeRange;
    $[20] = applyRange;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== anchorEl || $[24] !== t11 || $[25] !== t6) {
    t12 = <Menu anchorEl={anchorEl} open={t6} onClose={t7} minWidth={DROPDOWN_WIDTH} slotProps={t8}>{t11}</Menu>;
    $[23] = anchorEl;
    $[24] = t11;
    $[25] = t6;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t5) {
    t13 = <Box component="div">{t5}{t12}</Box>;
    $[27] = t12;
    $[28] = t5;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}